import React, { useState } from "react";
import { Button, Dropdown, Message, Modal } from "../../../../../../BP2Components";
import { Icon_ChatOptions } from "../../../../../../BP2Components/Icons/icons";
import IntlMessages from "../../../../../../../util/IntlMessages";
import { useSelector, DefaultRootState, useDispatch } from "react-redux";
import { useChat } from "../../../../../../../context/ChatContext/ChatContext";
import { changeRoomStatus, deleteRoom } from "../../../firebaseCRUD";
import { setChatSettings, setIsChatOpen } from "../../../../../../../appRedux/actions/ChatSettings";
import { useIntl } from "react-intl";
import { addComment } from "../../../../../../../services/restAPI/RestApi";
import { getMessageStep } from "../../../../../../../services/api/Api";
import { setComments } from "../../../../../../../appRedux/actions/FormsV2";
import ChatChangeRoomName from "../../../ChatSettings/ChatChangeRoomName";

interface ChatSettingsProps {
   instanceId: string;
   actionIdFromUrl: string | null;
}

const ChatSettings: React.FC<ChatSettingsProps> = ({ instanceId, actionIdFromUrl }) => {
   const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
   const [summary, setSummary] = useState<string | null>(null);

   const chatSettings = useSelector((state: DefaultRootState) => state.chatSettings);
   const chatData = useChat();

   const dispatch = useDispatch();
   const intl = useIntl();

   const chatButtonsOptionList = [
      {
         id: 1,
         name: <IntlMessages id={!!instanceId ? "chat.saveAndClose" : "chat.removeChat"} />,
         onClick: () => {
            !!instanceId
               ? handleSaveAndClose()
               : handleChangeChatStatus(chatSettings, chatData?.chatData?.allRooms);
         },
      },
   ];

   const handleChatOptionsClick = (e) => {
      e.preventDefault();
      setIsDropdownOpen((prevOpen) => !prevOpen);
   };

   const handleSaveAndClose = () => {
      const chatMessages = [
         ...chatData?.chatData?.messages?.filter(
            (message) => message?.roomId === chatSettings?.currentRoom?.id,
         ),
      ];

      const chatSummary = chatMessages?.reduce((chatSum, message) => {
         chatSum += `<span>${message.chatUser}</span> <span>${message.date}</span><br/><span>${message.content}</span><br/><br/>`;
         return chatSum;
      }, "");
      setSummary(chatSummary);
   };
   const handleChangeChatStatus = (selectedRoom, allRooms) => {
      // we find the room first, because there is a chance that it has just been created,
      // and when creating a new room, the "key" parameter, which is needed to update the value,
      // is not returned from the database.
      const foundRoom = allRooms?.find((room) => room.id === selectedRoom?.currentRoom?.id);

      // changing room status to "closed"
      changeRoomStatus("rooms/", foundRoom?.key, "archived");
      dispatch(
         setChatSettings({
            ...chatSettings,
            currentRoom: {},
         }),
      );
   };

   const handleSummarySubmit = async (e) => {
      try {
         e.preventDefault();
         Message.loading(intl.formatMessage({ id: "global.loading" }), 0);

         // We need to access the value this way, because contentEditable is not
         // handled properly via FormData
         const summaryContent = (
            `<span>Notatka pochodzi z chatu: ${chatSettings?.currentRoom?.id}</span><br/><br/>` +
            e.target.children[0].innerHTML
         )
            .replace(/<div bis_skin_checked="1">/g, "<span>")
            .replace(/<\/div>/g, "</span><br>")
            .replace(/\n/g, "<br>");

         await addComment({ instId: instanceId }, summaryContent);

         const queries = new URLSearchParams(window.location.search);
         if (queries && queries.has("actionId") && queries.has("mailBoxId")) {
            const stepData = await getMessageStep(actionIdFromUrl);
            dispatch(setComments(stepData?.data?.step?.comments));
         }

         deleteRoom("rooms/", await chatSettings?.currentRoom?.key);
         dispatch(setChatSettings({ currentRoom: {} }));
         dispatch(setIsChatOpen(false));

         Message.destroy();
         Message.success(intl.formatMessage({ id: "global.done" }));
         setSummary(null);
      } catch {
         Message.destroy();
         Message.error(intl.formatMessage({ id: "chat.addingSummaryError" }));
      }
   };

   return (
      <>
         <div
            className="chat-options-buttons right-button"
            onClick={(e) => handleChatOptionsClick(e)}
         >
            <Dropdown
               //@ts-ignore
               items={chatButtonsOptionList}
               isOpen={isDropdownOpen}
               setIsOpen={setIsDropdownOpen}
               customZIndex={1000}
               checkForModalRoot={false}
            />
            <Icon_ChatOptions fill="#64748b" stroke="#64748b" />
         </div>

         <Modal
            width={window?.innerWidth / 1.2}
            onCancel={() => setSummary(null)}
            topBarContent={
               <>
                  <IntlMessages
                     id={chatSettings?.currentRoom?.title?.match(/([^\s]+)\s(.*)/)?.[1]}
                  />{" "}
                  {chatSettings?.currentRoom?.title?.match(/([^\s]+)\s(.*)/)?.[2]}
               </>
            }
            isOpen={!!summary}
         >
            <form onSubmit={handleSummarySubmit} className="chat-summary">
               <div
                  contentEditable={true}
                  className="chat-summary__input"
                  //@ts-ignore
                  dangerouslySetInnerHTML={{ __html: summary }}
               />
               <Button htmlType="submit" className="chat-summary__submit">
                  <IntlMessages id="global.save" />
               </Button>
            </form>
         </Modal>
      </>
   );
};

export default ChatSettings;
